import { useTranslation } from 'react-i18next';
import { DatePickerRange } from '../../Components/DatePickerRange/DatePickerRange';
import { AutocompleteMultipleChoice } from '../../Components/AutocompleteMultichoice/AutocompleteMultichoice';
import { NumberTextField } from '../../Components/NumberTextField/NumberTextField';
import { namespaces } from '../../../../../../i18n/i18n.constants';

import { FilterListWrapper } from '../../Wrappers/FilterListWrapper/FilterListWrapper';

import FILTER_TYPES from '../../../../../../config/filtersConfig/filterTypes';
import { ClassificationGroups } from '../../Components/ClassificationGroups/ClassificationGroups';
import { SelectFilter } from '../../Components/SelectFilter/SelectFilter';
import { SelectMultipleFilter } from '../../Components/SelectMultipleFilter/SelectMultipleFilter';

export const CivilWorksFiltersList = () => {
  const { t } = useTranslation(namespaces.pages.resumesSearch);
  return <FilterListWrapper
    filterListTitle={FILTER_TYPES.civilWorksFilters}
    // ACPQ1-1188 - Set columnType to civilWorks
    columnType='civilWorks'
  >
    <AutocompleteMultipleChoice filterType={FILTER_TYPES.civilWorksByName} />
    <NumberTextField filterType={FILTER_TYPES.civilWorksMinimunAmount} />
    <AutocompleteMultipleChoice filterType={FILTER_TYPES.civilWorksClient} />
    <DatePickerRange filterType={FILTER_TYPES.civilWorksBeginningDate} />
    <DatePickerRange filterType={FILTER_TYPES.civilWorksEndDate} />
    <SelectMultipleFilter
      filterType={FILTER_TYPES.civilWorksType}
      tooltipMessage={t('tooltip.or_civilWorks')}
    />
    <SelectMultipleFilter
      filterType={FILTER_TYPES.civilWorksSubtype}
      tooltipMessage={t('tooltip.or_civilWorks')}
    />
    <ClassificationGroups filterType={FILTER_TYPES.civilWorksClassification} />
    <SelectFilter filterType={FILTER_TYPES.civilWorksCertificate} />
    <AutocompleteMultipleChoice filterType={FILTER_TYPES.civilWorksZone} />
    <SelectMultipleFilter
      filterType={FILTER_TYPES.civilWorksContructiveProcesses}
      tooltipMessage={t('tooltip.or_civilWorks')}
    />
  </FilterListWrapper>;
};
